import { SELECTORS } from '../../utils/constants';

const initKlaviyoBis = () => {
  const klaviyoBisEl = document.querySelector('[data-klaviyo-bis]');
  if (!klaviyoBisEl) return;
  const klaviyoBisForm = klaviyoBisEl.querySelector('form');
  const klaviyoBisFormSubmitBtn = klaviyoBisForm.querySelector('button[type="submit"]');
  const klaviyoBisFormSpinner = klaviyoBisFormSubmitBtn.querySelector(SELECTORS.LOADING_SPINNER);
  const klaviyoBisEmail = klaviyoBisForm.querySelector('input');
  const klaviyoBisSuccessEl = klaviyoBisEl.querySelector('[data-klaviyo-success]');

  const subscribeBackInStock = async (email) => {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: `${email}`,
              },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${klaviyoBisEl.dataset.unavailableVariantId}`,
            },
          },
        },
      },
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-06-15',
      },
      body: JSON.stringify(payload),
    };

    try {
      const response = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${klaviyoBisEl.dataset.klaviyoBis}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      klaviyoBisForm.classList.add('hidden');
      klaviyoBisSuccessEl.classList.remove('hidden');
    } catch (error) {
      console.error('Error:', error);
    }
  };

  klaviyoBisForm.addEventListener('submit', (evt) => {
    evt.preventDefault();
    klaviyoBisFormSubmitBtn.disabled = true;
    klaviyoBisFormSpinner.classList.remove('hidden');
    subscribeBackInStock(klaviyoBisEmail.value);
  });
};

export default initKlaviyoBis;
